<div
  *ngIf="
    remoteDiagnosticsSnapshotsStore.getVddSnapshotAndCurrentValues(vddName, logicalLink)
      | async as vddData
  "
>
  <ng-template [ngIf]="snapshotTypeEnum.SNAPSHOT" [ngIfElse]="backupTemplate">
    <!-- vdd name column: 20%, current backup values column: 40%, backup to compare column: 40% -->
    <ng-template [ngIf]="!fullWidthMode" [ngIfElse]="fullWidthModeTemplate">
      <div class="vdd-row flex flex-row">
        <!-- name column -->
        <div class="border-bottom word-break flex-[20%] max-w-[20%]">
          <div class="vdd-name flex flex-col justify-start items-start">
            <div>{{ 'TI_' + vddName | translate }}</div>
            <small [attr.id]="vddName">{{ vddName }}</small>
            <small>{{ getFullNameOFControlUnit(logicalLink) }}</small>
          </div>
        </div>
        <div
          *ngIf="vddDetailsListStore.isVddLoading(vddName, logicalLink) | async; else vddLoaded"
          class="flex flex-row justify-center items-center flex-[100%] max-w-[50%]"
        >
          <mat-spinner></mat-spinner>
        </div>
        <ng-template #vddLoaded>
          <!-- current values column -->
          <div
            data.at-currentValue
            class="border-bottom flex-[40%] max-w-[40%]"
            *ngIf="remoteDiagnosticsSnapshotsStore.getDateOfTheValuesRead$ | async"
          >
            <div
              class="flex flex-col justify-center items-center"
              *ngIf="vddData.currentValue?.length; else readError"
            >
              <div
                *ngFor="let matchedValue of vddData.currentValue"
                class="full-width vdd-value flex flex-row"
              >
                <span class="flex-[40%] max-w-[40%]"
                  >{{ matchedValue.translationid | translate }}
                  <span *ngIf="matchedValue.value">:</span></span
                >
                <span *ngIf="matchedValue.value" class="flex-[60%] max-w-[60%]"
                  >{{ matchedValue.value | decimalPipe }} {{ ' ' }} {{ matchedValue.unit }}</span
                >
              </div>
            </div>
            <ng-template #readError>
              <vi-alert>
                <strong>{{ 'DIAGNOSTICS.VDD_CANNOT_BE_DISPLAYED' | translate }}</strong>
              </vi-alert>
            </ng-template>
          </div>
          <!-- selected snapshot column -->
          <div
            data.at-selectedSnapshot
            *ngIf="remoteDiagnosticsSnapshotsStore.selectedSnapshot$ | async"
            class="border-bottom flex-[40%] max-w-[40%]"
          >
            <div
              class="flex flex-col justify-center items-center"
              *ngIf="vddData.snapshotValue?.length; else readError"
            >
              <div
                *ngFor="let matchedValue of vddData.snapshotValue"
                class="full-width vdd-value flex flex-row"
              >
                <span class="flex-[40%] max-w-[40%]"
                  >{{ matchedValue.translationid | translate }}
                  <span *ngIf="matchedValue.value">:</span></span
                >
                <span *ngIf="matchedValue.value" class="flex-[60%] max-w-[60%]"
                  >{{ matchedValue.value | decimalPipe }} {{ ' ' }} {{ matchedValue.unit }}</span
                >
              </div>
            </div>
            <ng-template #readError>
              <vi-alert>
                <strong>{{ 'DIAGNOSTICS.VDD_CANNOT_BE_DISPLAYED' | translate }}</strong>
              </vi-alert>
            </ng-template>
          </div>
        </ng-template>
      </div>
    </ng-template>

    <!--FULL WIDTH MODE vdd name column: 40%, current snapshot values column: 60% -->
    <ng-template #fullWidthModeTemplate>
      <div class="vdd-row flex flex-row">
        <div class="border-bottom word-break flex-[40%] max-w-[40%]">
          <div class="vdd-name flex flex-col justify-start items-start">
            <div>{{ 'TI_' + vddName | translate }}</div>
            <small [attr.id]="vddName">{{ vddName }}</small>
            <small>{{ getFullNameOFControlUnit(logicalLink) }}</small>
          </div>
        </div>
        <div
          *ngIf="vddDetailsListStore.isVddLoading(vddName, logicalLink) | async; else vddLoaded"
          class="flex flex-row justify-center items-center flex-[100%] max-w-[50%]"
        >
          <mat-spinner></mat-spinner>
        </div>
        <ng-template #vddLoaded>
          <div
            class="border-bottom flex-[60%] max-w-[60%]"
            *ngIf="remoteDiagnosticsSnapshotsStore.getDateOfTheValuesRead$ | async"
          >
            <div
              class="flex flex-col justify-center items-center"
              *ngIf="vddData.currentValue?.length; else readError"
            >
              <div
                *ngFor="let matchedValue of vddData.currentValue"
                class="full-width vdd-value flex flex-row"
              >
                <span class="flex-[40%] max-w-[40%]"
                  >{{ matchedValue.translationid | translate }}
                  <span *ngIf="matchedValue.value">:</span></span
                >
                <span *ngIf="matchedValue.value" class="flex-[60%] max-w-[60%]"
                  >{{ matchedValue.value | decimalPipe }} {{ ' ' }} {{ matchedValue.unit }}</span
                >
              </div>
            </div>
            <ng-template #readError>
              <vi-alert>
                <strong>{{ 'DIAGNOSTICS.VDD_CANNOT_BE_DISPLAYED' | translate }}</strong>
              </vi-alert>
            </ng-template>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </ng-template>

  <ng-template #backupTemplate>
    <div class="vdd-row flex flex-row">
      <!-- name column -->
      <div class="border-bottom word-break flex-[20%] max-w-[20%]">
        <div class="vdd-name flex flex-col justify-start items-start">
          <div>{{ 'TI_' + vddName | translate }}</div>
          <small [attr.id]="vddName">{{ vddName }}</small>
          <small>{{ getFullNameOFControlUnit(logicalLink) }}</small>
        </div>
      </div>
      <div
        *ngIf="vddDetailsListStore.isVddLoading(vddName, logicalLink) | async; else vddLoaded"
        class="flex flex-row justify-center items-center flex-[100%] max-w-[50%]"
      >
        <mat-spinner></mat-spinner>
      </div>
      <ng-template #vddLoaded>
        <!-- current values column -->
        <div
          data.at-currentValue
          class="border-bottom flex-[40%] max-w-[40%]"
          *ngIf="remoteDiagnosticsSnapshotsStore.getDateOfTheValuesRead$ | async"
        >
          <div
            class="flex flex-col justify-center items-center"
            *ngIf="vddData.currentValue?.length; else readError"
          >
            <div
              *ngFor="let matchedValue of vddData.currentValue"
              class="full-width vdd-value flex flex-row"
            >
              <span class="flex-[40%] max-w-[40%]"
                >{{ matchedValue.translationid | translate }}
                <span *ngIf="matchedValue.value">:</span></span
              >
              <span *ngIf="matchedValue.value" class="flex-[60%] max-w-[60%]"
                >{{ matchedValue.value | decimalPipe }} {{ ' ' }} {{ matchedValue.unit }}</span
              >
            </div>
          </div>
          <ng-template #readError>
            <vi-alert>
              <strong>{{ 'DIAGNOSTICS.VDD_CANNOT_BE_DISPLAYED' | translate }}</strong>
            </vi-alert>
          </ng-template>
        </div>
        <!-- selected backup column -->
        <div
          data.at-selectedSnapshot
          *ngIf="remoteDiagnosticsSnapshotsStore.selectedSnapshot$ | async"
          class="border-bottom flex-[40%] max-w-[40%]"
        >
          <div
            class="flex flex-col justify-center items-center"
            *ngIf="vddData.snapshotValue?.length; else readError"
          >
            <div
              *ngFor="let matchedValue of vddData.snapshotValue"
              class="full-width vdd-value flex flex-row"
            >
              <span class="flex-[40%] max-w-[40%]"
                >{{ matchedValue.translationid | translate }}
                <span *ngIf="matchedValue.value">:</span></span
              >
              <span *ngIf="matchedValue.value" class="flex-[60%] max-w-[60%]"
                >{{ matchedValue.value | decimalPipe }} {{ ' ' }} {{ matchedValue.unit }}</span
              >
            </div>
          </div>
          <ng-template #readError>
            <vi-alert>
              <strong>{{ 'DIAGNOSTICS.VDD_CANNOT_BE_DISPLAYED' | translate }}</strong>
            </vi-alert>
          </ng-template>
        </div>
      </ng-template>
    </div>
  </ng-template>
</div>
